import "react-phone-number-input/style.css";

import { yupResolver } from "@hookform/resolvers/yup";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Controller, useForm } from "react-hook-form";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

import { InlineError } from "../components/Notifications/Error";
import Loader from "../components/Notifications/Loader";
import TitleDescription from "../components/TitleDescription";
import { Input, Message, RadioButtonInput } from "../components/UsedInputs";
import { ContactFormValidation } from "../components/Validations/ContactFormValidation";
// import { contactScreenAction } from "../Redux/Actions/ClientFormAction";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { contact_Image } from "../constants/imageConstants";
import { contactScreenAction } from "../redux/actions/clientFormAction";

const id = Math.floor(Math.random() * 1000000000);
const workorder_id = Math.floor(Math.random() * 1000000000);

// User defined Imports
function Contact({ gapFour }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [selectedValues, setSelectedValues] = useState();


  // validate user
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ContactFormValidation),
  });

  // on submit
  const onSubmit = async (data) => {
    const endData = {...data, area: "", place_type: ""}
    setLoading(true);
    await dispatch(
      contactScreenAction(
        endData,
        setLoading,
        id,
        workorder_id,
      )
    );
    setTimeout(() => {
      reset();
      setSelectedValues([]);
      setLoading(false);
    }, 1000);
  };

  const onErrors = (errors) => console.log(errors);

  return (
    <>
      <Helmet>
        <title>Ziva Interiors</title>
        <meta name="description" content="Contact us through your email" />
        <link rel="canonical" href="/#contact-us" />
      </Helmet>
      <section id="contact" className={gapFour}>
        <h1 className="text-4xl contact text-center mt-5 text-black text-bold uppercase">
          Submit a <span className="text-main">request</span>
        </h1>
        <div>
          <form onSubmit={handleSubmit(onSubmit, onErrors)}>
            <div className="lg:px-20 px-4 grid lg:grid-cols-2  grid-cols gap-6 ">
              <div
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <TitleDescription
                  title=""
                  image={contact_Image}
                  description="Do you have any interior design requirement for your home or commercial space?"
                  description2="Call us & talk to our expert today!"
                />
              </div>
              <div
                data-aos="fade-up"
                data-aos-offset="300"
                data-aos-easing="ease-in-out"
                className="flex flex-col gap-3"
              >
                <div className="w-full">
                  <h1 className="lg:text-4xl text-3xl">
                    Lets talk about your Interior requirements
                  </h1>
                  <div className="flex lg:justify-start justify-center">
                    <p className="border-b-2 border-main lg:w-40 w-40  my-5"></p>
                  </div>
                </div>
                <div className="w-full">
                  <Input
                    label=""
                    placeholder="Your Name"
                    type="text"
                    bg={true}
                    name="name"
                    register={register}
                    error={errors.name}
                    style={"capitalize"}
                  />
                  {errors.name && <InlineError text={errors.name.message} />}
                </div>
                <div className="w-full">
                  <Controller
                    name="phonenumber"
                    control={control}
                    rules={{
                      validate: (value) => isValidPhoneNumber(value),
                    }}
                    render={({ field: { onChange, value } }) => (
                      <PhoneInput
                        value={value}
                        onChange={onChange}
                        defaultCountry="IN"
                        id="phonenumber"
                        className={`w-full text-sm mt-2 p-5 border border-grey-800 rounded text-main ${errors.phonenumber
                          ? "border-red-600 border-2"
                          : "focus:border-subMain focus:border-2"
                          } ${true ? "bg-white" : "bg-dry"}`}
                      />
                    )}
                  />
                  {errors.phonenumber && (
                    <InlineError text={errors.phonenumber.message} />
                  )}
                </div>
                <div className="w-full">
                  <Input
                    label=""
                    placeholder="Your Email"
                    type="email"
                    bg={true}
                    name="email"
                    register={register}
                    error={errors.email}
                  />
                  {errors.email && <InlineError text={errors.email.message} />}
                </div>
                <div className="w-full">
                  <h1>Type of Project</h1>
                  <div className="flex flex-row gap-3 items-center mt-3">
                    <RadioButtonInput
                      id="residential"
                      name="Residential"
                      label="Residential"
                      register={register}
                      refer="typeOfProject"
                      value="residential"
                    />
                    <RadioButtonInput
                      id="commercial"
                      name="Commercial"
                      label="Commercial"
                      register={register}
                      refer="typeOfProject"
                      value="commercial"
                    />
                    <RadioButtonInput
                      id="other"
                      name="Other"
                      label="Other"
                      register={register}
                      refer="typeOfProject"
                      value="other"
                    />
                  </div>
                  {errors.typeOfProject && <InlineError text={errors.typeOfProject.message} />}

                </div>
                <div>
                  <Message
                    name="message"
                    type="text"
                    register={register}
                    label=""
                    placeholder="Additional Information or Design Preferences"
                    error={false}
                  />

                </div>

                <div
                  className="flex flex-col items-center justify-center lg:my-5 md:my-5 my-5 mb-10"
                >
                  <motion.button
                    whileHover={{
                      scale: 1,
                      textShadow: "0px 0px 2px rgb(0,0,0)",
                      boxShadow: "0px 0px 6px rgb(0,0,0)",
                    }}
                    aria-label="Submit"
                    type="submit"
                    disabled={isLoading}
                    className={`bg-main border-none text-white uppercase rounded ${isLoading ? "" : "p-4"
                      } w-80`}
                  >
                    {isLoading ? <Loader /> : "Submit"}
                  </motion.button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}

export default Contact;
